<div class="py-8 hero">
  <div class="px-8">
    <div class="breadcrumbs">
      <ng-content select=".hero-breadcrumbs"></ng-content>
    </div>
    @if (title) {
      <div class="flex pb-3">
        <div>
          <h1 class="relative grow-0 inline-block px-0 py-1 mr-16 font-serif font-thin text-white -top-2">
            <ng-content select=".hero-title-prefix"></ng-content>{{ title }}<ng-content select=".hero-title-suffix"></ng-content>
            <span class="absolute m-2 -mt-4"><ng-content select=".hero-counter"></ng-content></span>
          </h1>
        </div>
        <div class="relative flex flex-row justify-between grow -top-1">
          <div>
            <ng-content select=".hero-buttons"></ng-content>
          </div>
          <ng-content select=".hero-right-content"></ng-content>
        </div>
      </div>
    }
    <p class="relative mb-2 -top-2 hero-subtitle"><ng-content select=".hero-subtitle-content"></ng-content></p>
  </div>
</div>
